<script setup lang="ts">
import { computed } from 'vue';
import { useOrganizationStore } from '~/store/organization';

const { organization } = storeToRefs(useOrganizationStore());
const { t } = useI18n();

const email = computed<string>(() => {
  return organization.value?.supportEmail ?? 'support@email.exfluential.com';
});
</script>

<template>
  <footer
    class="w-full border-t max-w-[90rem] mx-auto space-y-5 py-8 md:py-6 px-4"
  >
    <div class="text-sm text-on-background-variant text-center">
      {{ t('footer.need-help') }} <span class="font-bold">{{ email }}</span>
      <br />
      {{ t('footer.powered-by') }} Exfluential
    </div>

    <div
      v-if="
        organization &&
        organization.isCustomFooterEnabled &&
        organization.customFooterContent
      "
      class="prose max-w-full text-on-background"
      v-html="organization.customFooterContent"
    />
  </footer>
</template>
